import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Link } from "wouter";
import logoFullColor from "@assets/MAPA35_logo_fullcolor_small.webp";

export function AnimatedBlock({
  children,
  delay = 0,
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 16 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 16 }}
      transition={{ duration: 0.4, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}

export function SimpleHeader() {
  return (
    <header className="border-b border-border/40 bg-background">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-2">
        <Link href="/" className="flex items-center flex-shrink-0" data-testid="link-logo-home">
          <img src={logoFullColor} alt="MAPA35" className="h-8 w-auto" width={255} height={72} />
        </Link>
        <nav className="flex items-center gap-3 sm:gap-6 text-sm">
          <Link href="/faq" className="hidden sm:inline text-muted-foreground hover:text-foreground transition-colors" data-testid="link-nav-faq">
            FAQ
          </Link>
          <Link href="/glosario" className="hidden sm:inline text-muted-foreground hover:text-foreground transition-colors" data-testid="link-nav-glosario">
            Glosario
          </Link>
          <Link href="/blog" className="hidden sm:inline text-muted-foreground hover:text-foreground transition-colors" data-testid="link-nav-blog">
            Blog
          </Link>
          <Link href="/#contacto" className="text-primary font-medium whitespace-nowrap" data-testid="link-nav-contacto">
            Solicitar diagnóstico
          </Link>
        </nav>
      </div>
    </header>
  );
}

export function SimpleFooter() {
  return (
    <footer className="py-10 border-t mt-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <Link href="/" className="flex items-center" data-testid="link-footer-logo">
          <img src={logoFullColor} alt="MAPA35" className="h-6 w-auto" width={255} height={72} loading="lazy" />
        </Link>
        <div className="flex flex-wrap items-center gap-6 text-xs text-muted-foreground">
          <Link href="/" data-testid="link-footer-home">Inicio</Link>
          <Link href="/faq" data-testid="link-footer-faq">Preguntas frecuentes</Link>
          <Link href="/glosario" data-testid="link-footer-glosario">Glosario NOM-035</Link>
          <Link href="/blog" data-testid="link-footer-blog">Blog</Link>
        </div>
      </div>
    </footer>
  );
}
